const ModalDispatcher = {
  showDuplicateEmailModal({ show, error = '' }) {
    if (error.includes('csecondaryemail')) {
      this.setStoreVal('coapplicantIsDuplicate', true);
    }
    switch (show) {
      case true:
        this.setStoreVal('showDuplicateEmailModal', true);
        break;
      case false:
        this.setStoreVal('showDuplicateEmailModal', false);
        break;
      default:
        this.setStoreVal('showDuplicateEmailModal', false);
    }
  },
};

export default ModalDispatcher;
